export function setDefaultInfoStatus(isClosed: boolean) {
  localStorage.setItem('InfoClosed', isClosed ? 'closed' : 'open');
}

export function getDefaultInfoStatus() {
  const infoSeen = localStorage.getItem('InfoClosed');
  return infoSeen !== 'closed';
}

